/**
 * /trash - 휴지통 페이지
 * [2026-02-24] 최초 작성
 * 소프트 삭제된 문서를 관리자/작성자가 조회·복원·영구삭제하는 페이지
 */

import { Suspense } from 'react';
import TrashClient from './TrashClient';

export default function TrashPage() {
    return (
        <Suspense fallback={
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-red-500" />
            </div>
        }>
            <TrashClient />
        </Suspense>
    );
}
